let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lfI2y")).then(() => parcelRequire('c33Km'));